import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "This is a message", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, _mergeProps({
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.dialogVisible = $event),
    width: $props.width,
    title: $props.title,
    top: $props.top,
    center: $props.center,
    "append-to-body": true,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "before-close": $setup.handleClickCancel
  }, _ctx.$attrs, {
    "custom-class": `form-dialog basic-dialog ${$props.customClass}`,
    onOpened: $setup.opened
  }), {
    footer: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["my-dialog-footer", {
        'one-btn': !($props.confirm && $props.cancel),
        'two-btn': $props.confirm && $props.cancel
      }])
    }, [_renderSlot(_ctx.$slots, "foot", {}, () => [$props.confirm && $props.cancel ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", {
      class: "btn submit",
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $setup.handleClickConfirm && $setup.handleClickConfirm(...args), ["stop"]))
    }, _toDisplayString($props.confirm), 1), _createVNode(_component_el_button, {
      onClick: _withModifiers($setup.handleClickCancel, ["stop"])
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.cancel), 1)]),
      _: 1
    }, 8, ["onClick"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [$props.cancel ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "btn",
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $setup.handleClickCancel && $setup.handleClickCancel(...args), ["stop"]))
    }, _toDisplayString($props.cancel), 1)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "btn",
      onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $setup.handleClickConfirm && $setup.handleClickConfirm(...args), ["stop"]))
    }, _toDisplayString($props.confirm || _ctx.$t('message.Confirm')), 1))], 64))])], 2)]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_hoisted_1])]),
    _: 3
  }, 16, ["modelValue", "width", "title", "top", "center", "before-close", "custom-class", "onOpened"]);
}